<template>
  <div id="page-jobfeed-edit">
    <vs-alert
      color="danger"
      title="JobFeed Not Found"
      :active.sync="jobfeed_not_found"
    >
      <span>
        JobFeed record with id
        <strong>{{ $route.params.jobFeedId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'jobfeed-list' }"
          class="text-inherit underline"
          >All JobFeeds</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="data">
      <dx-validation-group ref="validation-group">
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("JobFeed.Name") }}
            </div>
            <div class="dx-field-value">
              <DxTextBox :value.sync="data.name">
                <DxValidator>
                  <DxRequiredRule :message="$t('JobFeed.NameRequired')" />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("JobFeed.IdJobFeedType") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="jobFeedTypes"
                :search-enabled="true"
                :value.sync="data.idJobFeedType"
                display-expr="name"
                value-expr="id"
                ><DxValidator>
                  <DxRequiredRule
                    :message="$t('JobFeed.JobFeedTypeRequired')"
                  />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("JobFeed.FeedUrl") }}
            </div>
            <div class="dx-field-value">
              <DxTextBox :value.sync="data.feedUrl">
                <DxValidator>
                  <DxRequiredRule :message="$t('JobFeed.FeedUrlRequired')" />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>
        </div>
      </dx-validation-group>
    </vx-card>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveChanges">{{
            this.$t("Save")
          }}</vs-button>
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="cancel"
            >{{ this.$t("Cancel") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import moduleJobFeedManagement from '@/store/job-feed-management/moduleJobFeedManagement.js'
import moduleRefCodes from '@/store/refcodes/moduleRefCodes.js'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'
import { notifyMixin } from '@/mixins/notifyMixin'


export default {
  mixins: [notifyMixin],
  data () {
    return {
      data: null,
      jobfeed_not_found: false,
      jobFeedTypes: []
    }
  },
  components: {
    DxSelectBox,
    DxTextBox,
    DxValidator,
    DxValidationGroup,
    DxRequiredRule,
  },
  computed: {
    ...mapGetters(["activeOrganisation"]),
  },
  methods: {
    fetchJobFeedData (jobFeedId) {
      this.$store.dispatch('jobFeedManagement/fetchJobFeed', jobFeedId)
        .then(res => {
          this.data = res.data.jobFeed
          if (!jobFeedId) {
            this.data.idOrganisation = this.activeOrganisation.id
          }
          if (this.data === null) {
            this.jobfeed_not_found = true
          }
          Promise.all([this.fetchJobFeedTypes()])
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.jobfeed_not_found = true
            return
          }
          console.error(err)
        })
    },
    saveChanges () {
      const validationGroup = this.$refs["validation-group"].instance
      const result = validationGroup.validate()
      if (!result.isValid) {
        return
      }

      this.$store.dispatch('jobFeedManagement/saveJobFeed', this.data)
        .then(() => {
          this.$router.push("/jobfeed/list")
          this.jobFeedId ? this.notifySuccess(this.$t("JobFeed.Updated")) : this.notifySuccess(this.$t("JobFeed.Added"))
        })
        .catch(err => { console.error(err) })
    },
    cancel () {
      this.$router.push("/jobfeed/list")
    },
    fetchJobFeedTypes () {
      this.$store.dispatch('refcodes/fetchJobFeedTypes')
        .then(res => {
          this.jobFeedTypes = res.data.items
        })
    },
  },
  created () {
    if (!moduleJobFeedManagement.isRegistered) {
      this.$store.registerModule('jobFeedManagement', moduleJobFeedManagement)
      moduleJobFeedManagement.isRegistered = true
    }
    if (!moduleRefCodes.isRegistered) {
      this.$store.registerModule('refcodes', moduleRefCodes)
      moduleRefCodes.isRegistered = true
    }
    this.fetchJobFeedData(this.$route.params.jobFeedId)
  }
}

</script>
